<template>
	<!-- Seller Connection -->
	<modal
		class="verification-modal"
		@close="close"
        :size='"large"'>
		<template slot="header">
			<h3><b>{{ $t('Seller Connection') }}</b></h3>
		</template>
		<template slot="body">
			<div class="form-group">
				<label><b>{{ $t('Name') }}</b></label>
				<input type="text" class="form-control" disabled v-model="user.name">
			</div>
			<div class="form-group">
				<label><b>{{ $t('Connections') }}</b></label>
				<table v-if="!isFetching" class="table table-striped">
					<tbody>
						<tr v-for="(connection, index) in connections" :key="index">
							<td class="d-flex align-items-center">
								<div class="connection-row">
									{{ connection.source.name }} / {{connection.meta.browser}} {{connection.meta.device}} / {{connection.meta.location}}
									<div>
										<span class="badge badge-info">
											Connected at : {{ formatDate(moment, connection.created_at, 'DD/MM/YYYY - HH:mm') }}
										</span>
									</div>
								</div>
								<div class="ml-auto">
									<button type="button" class="integration-account__reconnect btn-plain btn-icon-danger" :class="{'is-loading' : isReconnecting}" @click="reconnect(connection)" v-tooltip="'Reconnect'">
										<i class="material-icons">refresh</i>
									</button>
								</div>
							</td>
						</tr>
						<tr v-if="connections.length == 0">
							<td class="text-center">No Connection Data</td>
						</tr>
					</tbody>
				</table>
				<div class="d-flex justify-content-center" v-if="isFetching">
					<div class="spinner-border" role="status">
						<span class="sr-only">Loading...</span>
					</div>
				</div>
			</div>
		</template>
		<template slot="footer">
			<button
				class="btn btn-light"
				@click="close">
					{{ $t('Close') }}
			</button>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import adminApi from '@/api/admin';
import {
	formatDate,
	getAxiosErrorMessage,
} from '@/lib/helper';

export default {
	name: 'ModalSellerConnection',
	components: {
		Modal,
	},
	props: {
		user: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			isFetching: true,
			isReconnecting: false,
			connections: [],
		};
	},
	methods: {
		formatDate,
		close() {
			this.$emit('close');
		},
		fetchConnection() {
			this.isFetching = true;

			const callback = (response) => {
				this.connections = response.data;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Error data tidak ada',
					text: message,
				});
				this.isFetching = false;
			};
			adminApi.sellerConnectionList(this.user?._id, callback, errorCallback);
		},
		reconnect(connection) {
			this.isReconnecting = true;
			const params = {
				user_id: this.user?._id,
			};

			const callback = (response) => {
				const newConnection = response.data;
				if (newConnection) {
					const connectionIndex = this.connections.findIndex(currentAccount => currentAccount._id === connection._id);
					if (connectionIndex !== -1) {
						this.$set(this.connections, connectionIndex, {
							...newConnection,
						});
					}
				}

				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Account Reconnect',
					text: 'Success Reconnecting Account',
				});

				this.isReconnecting = false;
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Account Reconnect',
					text: message,
				});
				this.isReconnecting = false;
			};

			adminApi.sellerConnectionReconnect(connection._id, params, callback, errorCallback);
		},
	},
	mounted() {
		this.fetchConnection();
	},
};
</script>
